import React from 'react';

type AppBrandProps = {
  logo: React.ReactNode;
  title?: React.ReactNode;
  clientVersion?: string;
  serverVersion?: string;
  collapsed?: boolean;
};

const AppBrand: React.FC<AppBrandProps> = ({
  logo,
  title,
  clientVersion = '-',
  serverVersion = '-',
  collapsed = false,
}) => {
  if (collapsed) {
    return <div className="aegis-brand aegis-brand-collapsed">{logo}</div>;
  }

  return (
    <div className="aegis-brand">
      <span className="aegis-brand-logo">{logo}</span>
      {title ? <span className="aegis-brand-title">{title}</span> : null}
      <div className="aegis-brand-versions">
        <span>S:{serverVersion}</span>
        <span>C:{clientVersion}</span>
      </div>
    </div>
  );
};

export default AppBrand;
